module.exports = __webpack_public_path__ + "moneyImg.614061e0c09401efe577.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/assets/img/moneyImg.jpg
// module id = ../../../../../src/assets/img/moneyImg.jpg
// module chunks = main